import { FC, ReactNode, useState } from 'react';
import { DSIcon, DSPopover, DSText } from '@stihl-design-system/components';

interface TooltipProps {
  id: string;
  content: string;
  anchor: ReactNode;
}

export const Tooltip: FC<TooltipProps> = ({ id, content, anchor }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  return (
    <DSPopover placement="top" isOpen={isOpen} onOpenChange={setIsOpen}>
      <DSPopover.Anchor onClick={onClick}>
        <button className="flex items-center gap-2 focus-outline max-w-fit">
          {anchor}
          <DSIcon name="circle-info-inverted" data-testid={`${id}-tooltip-icon`} />
        </button>
      </DSPopover.Anchor>
      <DSPopover.Content className="max-w-[230px] p-4">
        <DSText size="small">{content}</DSText>
      </DSPopover.Content>
    </DSPopover>
  );
};
